import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=b92b5b82&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/base.css?vue&type=style&index=0&id=b92b5b82&scoped=true&lang=css&"
import style1 from "./Base.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92b5b82",
  null
  
)

export default component.exports